"use client"

import { Button } from "@/components/ui/button";
import Image from "next/image";

// Global dataLayer type declaration
declare global {
  interface Window {
    dataLayer: any[];
  }
}

export default function FamilyOfBrandsSection() {
  return (
    <section className="w-full py-16">
      <div className="max-w-[1280px] mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-[#0D2B29] font-poppins uppercase mb-4">
            FlyLuxSky is a proud member<br />of the LuxeSkies Group
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Crafting the Future of Luxury Travel. Our family of brands is united by a single mission: 
            to deliver exceptional, personalized service and exclusive value across every journey.
          </p>
        </div>

        {/* Brand Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* FlyLuxSky Card */}
          <div className="bg-white rounded-2xl border border-gray-100 p-8">
            <div className="flex flex-col items-center text-center">
              {/* FlyLuxSky Logo */}
              <div className="w-32 h-32 flex items-center justify-center mb-6">
                <Image
                  src="/fls.png"
                  alt="FlyLuxSky Logo"
                  width={96}
                  height={96}
                  className="object-contain"
                />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Expert-Curated Luxury Travel
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                Your personal advisor for bespoke flight, hotel, cruise and transfer itineraries.
              </p>
            </div>
          </div>

          {/* LuxeSkies Card */}
          <div className="bg-white rounded-2xl border border-gray-100 p-8">
            <div className="flex flex-col items-center text-center">
              {/* LuxeSkies Logo */}
              <div className="w-32 h-32 flex items-center justify-center mb-6">
                <Image
                  src="/luxeskies.png"
                  alt="LuxeSkies Logo"
                  width={128}
                  height={128}
                  className="object-contain"
                />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Exclusive Business & First Class Flight Deals
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                Your destination for the world's best premium flight offers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}